<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.listaVTP')}} </h4>
        </div>
        <div class="page-header-inner">
            <div class="table-header">
                <div class="search-box">
                    <div class="search-form">
                        <input
                                type="search"
                                name="q"
                                :placeholder="$t('placeholder.cautaVTP')"
                                id="user-search"
                                v-model="search"
                                autocomplete="off"
                                @change="applyQuery({ q: search })"
                        >
                        <span class="focus-input"></span>
                        <span class="symbol-input" @click="applyQuery({ q: search })">
                                <i class="fas fa-search"></i>
                            </span>
                    </div>
                </div>
            </div>
            <div class="filters-section">

                <div class="filters-wrapper-inner">
                    <div class="filters-wrapper-main">
                        <div class="filters-select">
                            <div class="filterSelection">
                                <label> {{$t('placeholder.judet')}}: </label>
                              <!--  <v-select v-model="filters.county" :options="this.counties" label="name"
                                          @input="getCitiesByCounty()" placeholder="Judet"></v-select>-->
                            </div>
                            <div class="filterSelection">
                                <label> {{$t('placeholder.oras')}} </label>
                               <!-- <v-select v-model="filters.city" :options="this.cities" label="name"></v-select>-->
                            </div>
                        </div>
                    </div>
                    <div class="filters-button">
                        <button type="button" class="reset-filters" @click="resetFilters()">
                            <i class="fas fa-undo"></i>
                            {{$t('txt.reseteazaFiltre')}}
                        </button>
                        <button type="button" @click="filterUsers()">
                            {{$t('txt.filtreaza')}}
                            <i class="fas fa-filter"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="utilities-result-wrapper" v-if="this.$route.query.q">
            <p class="search-result" v-if="this.$route.query.q">
                <i class="fas fa-poll-h"></i>
                {{$t('txt.cautareDupa')}}: "{{this.searchBy}}"
            </p>
        </div>
        <div class="mobile-sorting">
            <div class="mobile-sort-by">
                <v-select :options="this.mobileSorting" v-model="sortMobile.sortMobileBy" @input="handleSortMobile(sortMobileBy, sortMobileType)" label="name" placeholder="Sorteaza dupa:">
                </v-select>
            </div>
            <div class="mobile-sort-method">
                <v-select :options="this.mobileSortingType" v-model="sortMobile.sortMobileType" @input="handleSortMobile(sortMobileBy, sortMobileType)" label="name" placeholder="Criteriu sortare:">
                </v-select>
            </div>
        </div>
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col" @click="handleSort('client')"> {{$t('tableHeader.numeClient')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'client' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'client' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('product')"> {{$t('tableHeader.numeProdus')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'product' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'product' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('done_date')"> {{$t('tableHeader.dataRealizata')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'done_date' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'done_date' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col" @click="handleSort('start_date')"> {{$t('tableHeader.dataDeRealizare')}}
                    <span class="sort-arrow"
                          v-if="this.$route.query.sort_by === 'start_date' && this.$route.query.sort_type === 'ASC'">
                            <i class="fas fa-arrow-circle-up"></i>
                        </span>
                    <span class="sort-arrow"
                          v-else-if="this.$route.query.sort_by === 'start_date' && this.$route.query.sort_type === 'DESC'">
                            <i class="fas fa-arrow-circle-down"></i>
                        </span>
                    <span class="sort-arrow" v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                </th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="vtps">
            <tr v-for="(vtp, index) in vtps" :key="index">
                <td :tableheadData="$t('tableHeader.numeClient')"> {{(vtp.client_name) ? vtp.client_name: '-'}}</td>
                <td :tableheadData="$t('tableHeader.numeProdus')"> {{(vtp.product_name) ? vtp.product_name : '-'}}</td>
                <td :tableheadData="$t('tableHeader.dataRealizata')"> {{(vtp.done_date) ? vtp.done_date : '-' }}</td>
                <td :tableheadData="$t('tableHeader.dataDeRealizare')"> {{(vtp.start_date) ? vtp.start_date: '-'}}</td>
                <td :tableheadData="$t('tableHeader.dataDeRealizare')" class="options-case">
                    <router-link :to="{ name: 'viewvtp', params: { id: vtp.id }}" class="view-user"
                                 data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                        <i class="fas fa-eye"></i>
                    </router-link>
                    <!-- <router-link :to="{ name: 'editpartner', params: { id: vtp.id }}" class="edit-user"
                                  data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                         <i class="fas fa-pen"></i>
                     </router-link>-->
                     <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip"
                        :title="$t('placeholder.sterge')" @click="removeVtp(index, vtp.id)">
                         <i class="fas fa-trash-alt"></i>
                     </a>
                </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
                <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
            </tr>
            </tbody>
            <tfoot v-if="vtps">
            <tr class="app_table_header">
                <th scope="col">
                    {{$t('tableHeader.numeClient')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.numeProdus')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.dataRealizata')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.dataDeRealizare')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.optiuni')}}
                </th>
            </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="vtps">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                    <div class="filter-results-number">
                        <label> {{$t('txt.afiseaza')}}: </label>
                        <select v-model="filters.per_page" @change="applyQuery({ per_page: filters.per_page })">
                            <option value="25"> {{$t('txt.rezultatePePagina',{nr:25})}} </option>
                            <option value="50"> {{$t('txt.rezultatePePagina',{nr:50})}} </option>
                            <option value="100"> {{$t('txt.rezultatePePagina',{nr:100})}} </option>
                        </select>
                    </div>
                </div>
                <ul class="pagination-box">
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: 1 })" class="Previous"><i
                                class="fas fa-angle-double-left pag-left"></i></a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== 1">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page-1 })"
                           class="Previous"><i class="fas fa-angle-left pag-left"></i></a>
                    </li>
                    <li class="pp-dot" v-for="page in pagination"
                        :class="{'pp-dot-active': meta.current_page === page }" :key="page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: page })">{{page}}</a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.current_page+1 })"><i
                                class="fas fa-angle-right pag-right"></i> </a>
                    </li>
                    <li class="pagination-point" v-if="this.meta.current_page !== this.meta.last_page">
                        <a href="javascript:void(0)" @click="applyQuery({ page: meta.last_page })"> <i
                                class="fas fa-angle-double-right pag-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ServiceServices from '../../api-services/service.service.js'
export default {
  name: 'servicevtp',
  data () {
    return {
      sortMobile: {
        sortMobileBy: null,
        sortMobileType: null
      },
      mobileSorting: [
        { key: 'client', name: 'Client' },
        { key: 'product', name: 'Produs' },
        { key: 'done_date', name: 'Data realizata' },
        { key: 'start_date', name: 'Data de realizare' }
      ],
      mobileSortingType: [
        { key: 'ASC', name: 'Crescator' },
        { key: 'DESC', name: 'Descrescator' }
      ],
      vtps: [],
      search: '',
      meta: {},
      filters: {
        county: null,
        city: null,
        per_page: 25
      }
    }
  },
  watch: {
    search: function (value) {
      if (!value) {
        this.applyQuery({ q: value })
      }
    },
    '$route.query' () {
      this.getVtp()
    }
  },
  computed: {
    sortMobileBy () {
      return (this.sortMobile.sortMobileBy) ? this.sortMobile.sortMobileBy.key : null
    },
    sortMobileType () {
      return (this.sortMobile.sortMobileType) ? this.sortMobile.sortMobileType.key : null
    },
    // return first page from pagination html
    start_page () {
      if (this.meta.last_page > 5 && this.meta.current_page > 2) {
        return this.meta.current_page - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page () {
      if (this.meta.last_page > 5 && this.meta.current_page + 2 < this.meta.last_page) {
        return this.meta.current_page + 2
      } else {
        return this.meta.last_page
      }
    },
    pagination () {
      let pages = []
      for (let i = this.start_page; i <= this.stop_page; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ path: '/service/vtp', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    },
    handleSortMobile (column, type) {
      if (column) {
        if (!this.sortMobile.sortMobileBy) {
          let found = this.mobileSorting.find(function (element) {
            return element.key === column
          })
          this.sortMobile.sortMobileBy = found
        }
        if (type) {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === type
            })
            this.sortMobile.sortMobileType = found
          }
        } else {
          if (!this.sortMobile.sortMobileType) {
            let found = this.mobileSortingType.find(function (element) {
              return element.key === 'ASC'
            })
            this.sortMobile.sortMobileType = found
          }
          type = this.sortMobile.sortMobileType.key
        }
        this.applyQuery({ sort_by: column, sort_type: type })
      } else {
        this.applyQuery({ sort_by: null, sort_type: null })
      }
    },
    getVtp () {
      ServiceServices.getAll()
        .then((response) => {
          this.vtps = response.data.data
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    removeVtp (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeLucrare'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          ServiceServices.delete(id)
            .then((response) => {
              this.$delete(this.vtps, index)
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.getVtp()
    let query = this.$route.query
    if (query.q) this.search = query.q
    if (query.sort_by && query.sort_type) {
      this.handleSortMobile(query.sort_by, query.sort_type)
    } else if (query.sort_by) {
      this.handleSortMobile(query.sort_by)
    }
  }
}
</script>
